<template>
    <show-base-template 
            v-on:edit='openEdit()' 
            v-on:delete='deleteItem()'
            :item='item' 
            :errors='errors' 
            :allowedit='allowedit' 
            :candelete='candelete'
            :title='title'
            :elementname='elementname'
            >
        <template v-slot:body>


            <div class="form-group d-flex">
                <div v-if='item.email' class="col-10">{{ $t('translations.id')}}: </div><div class="col-14">{{item.id}}</div>
            </div>

            <div class="form-group d-flex">
                <div v-if='item.email' class="col-10">{{ $t('translations.email')}}: </div><div class="col-14">{{item.email}}</div>
            </div>

            <div class="form-group d-flex">
                <div v-if='item.gender' class="col-10">{{ $t('translations.gender')}}: </div><div class="col-14">{{$root.lookup.genders[item.gender]}}</div>
            </div>

            <div class="form-group d-flex">
                <div v-if='item.age' class="col-10">{{ $t('translations.age')}}: </div><div class="col-14">{{item.age}}</div>
            </div>

            <div class="form-group d-flex" v-if='item.thread_id && !is_network_admin()' >
                <div class="col-10 align-self-center">{{ tBrandKey('request') | capitalise }}: </div><div class="col-14">{{getThreadDetails()}} <button class='btn btn-primary btn-round btn-sm' v-on:click='goToThread()'>{{ autobrand('translations.view_request')}}</button></div>
            </div>

            <div class="form-group d-flex">
                <div v-if='item.rating_text' class="col-10">{{ $t('translations.overall_rating')}}: </div><div class="col-14">{{item.rating_text}}</div>
            </div>

            <div class="form-group d-flex">
                <div v-if='item.message' class="col-10">{{ $t('translations.comment')}}: </div><div class="col-14" v-html='formatContent(item.message, true)'></div>
            </div>

            <div class="form-group d-flex">
                <div v-if='item.created_at' class="col-10">{{ $t('translations.created_at')}}: </div><div class="col-14">{{item.created_at | formatDateTime}}</div>
            </div>

            <hr>

            <template v-if='data'>
                <div class="form-group d-flex" v-for='(key) in Object.keys(data)' :key='key' >
                    <template v-if='key != "Request_ID" && (key != "Practice" || is_network_admin())'>
                        <div class="col-10" v-text='key.replace(/_/g, " ") + ": "'></div>
                        <div class="col-14" v-html='formatContent(data[key], true)'></div>
                    </template>
                </div>
            </template>

        </template>
        
    </show-base-template>
</template>

<script>
	export default {
        extends: app.base.showBase,
        props: [
        ],
        computed: {
            data() {
                if(this.item.data) {
                    return JSON.parse(this.item.data);
                }
                else {
                    return {};
                }
            },
            candelete() {
                return this.is_superuser() || this.is_network_admin();
            }
        },
        data() {
            return {
                event: "feedback",
                model: "feedback",
                title: "Feedback Entry",
                route: this.$root.apiBase + '/feedback',
                path: 'feedback',
                allowedit: false,
                
                elementname: "Feedback Entry",
            };
        },
        methods: {
            getName() {
                return this.item.id;
            },
            getThreadDetails() {
                var details = "";
                if(this.item && this.item.thread) {
                    details = this.formatName(this.item.thread.user) + ": " + this.item.thread.subject;
                }
                return details;
            },
            goToThread() {
                this.$router.push({path: "/thread-list/thread-show/" + this.item.thread.id});
            },
            parseData() {
                var render = "<ul>";
                if(this.item.data) {
                    var data = JSON.parse(this.item.data);


                }
                return "No extra data found for feedback";
            }
        }
    };
</script>